import React, { useState } from "react";

const EffectsOnHealth = () => {
  const [activeBlend, setActiveBlend] = useState("Lifestyle Management");

  return (
    <section className="fresh-vegetable-section section-lg-space">
      <div className="row">
        {/* Left Column */}
        <div className="col-xl-4 font-smd mb-3">
          <div className="">
            <div
              className={`mb-3 font-smd boder-radius-twenty ${
                activeBlend === "Lifestyle Management"
                  ? "active_background_white fw-semibold Main-colors "
                  : "grey_non_active fw-semibold"
              }`}
              onClick={() => setActiveBlend("Lifestyle Management")}
              style={{
                position: "relative",
                cursor: "pointer",
              }}
            >
              Lifestyle Management
              {activeBlend === "Lifestyle Management" && (
                <hr
                  style={{
                    position: "absolute",
                    right: 0,
                    top: 0,
                    bottom: 0,
                    opacity: 1,
                    height: "100%",
                    borderLeft: "5px solid var(--theme-color)",
                    margin: 0,
                  }}
                />
              )}
            </div>
            <div
              className={`mb-3 font-smd boder-radius-twenty ${
                activeBlend === "Healthy diet"
                  ? "active_background_white fw-semibold Main-colors "
                  : "grey_non_active fw-semibold"
              }`}
              onClick={() => setActiveBlend("Healthy diet")}
              style={{
                position: "relative",
                cursor: "pointer",
              }}
            >
              Healthy diet
              {activeBlend === "Healthy diet" && (
                <hr
                  style={{
                    position: "absolute",
                    right: 0,
                    top: 0,
                    bottom: 0,
                    opacity: 1,
                    height: "100%",
                    borderLeft: "5px solid var(--theme-color)",
                    margin: 0,
                  }}
                />
              )}
            </div>
            <div
              className={`mb-3 font-smd boder-radius-twenty ${
                activeBlend === "Reduced Carbohydrates and Metabolic syndrome"
                  ? "active_background_white fw-semibold Main-colors "
                  : "grey_non_active fw-semibold"
              }`}
              onClick={() =>
                setActiveBlend("Reduced Carbohydrates and Metabolic syndrome")
              }
              style={{
                position: "relative",
                cursor: "pointer",
              }}
            >
              Reduced Carbohydrates and Metabolic syndrome
              {activeBlend ===
                "Reduced Carbohydrates and Metabolic syndrome" && (
                <hr
                  style={{
                    position: "absolute",
                    right: 0,
                    top: 0,
                    bottom: 0,
                    opacity: 1,
                    height: "100%",
                    borderLeft: "5px solid var(--theme-color)",
                    margin: 0,
                  }}
                />
              )}
            </div>
            <div
              className={`mb-3 font-smd boder-radius-twenty ${
                activeBlend === "Exercise"
                  ? "active_background_white fw-semibold Main-colors "
                  : "grey_non_active fw-semibold"
              }`}
              onClick={() => setActiveBlend("Exercise")}
              style={{
                position: "relative",
                cursor: "pointer",
              }}
            >
              Exercise
              {activeBlend === "Exercise" && (
                <hr
                  style={{
                    position: "absolute",
                    right: 0,
                    top: 0,
                    bottom: 0,
                    opacity: 1,
                    height: "100%",
                    borderLeft: "5px solid var(--theme-color)",
                    margin: 0,
                  }}
                />
              )}
            </div>
            <div
              className={`mb-3 font-smd boder-radius-twenty ${
                activeBlend === "Medicine"
                  ? "active_background_white fw-semibold Main-colors "
                  : "grey_non_active fw-semibold"
              }`}
              onClick={() => setActiveBlend("Medicine")}
              style={{
                position: "relative",
                cursor: "pointer",
              }}
            >
              Medicine
              {activeBlend === "Medicine" && (
                <hr
                  style={{
                    position: "absolute",
                    right: 0,
                    top: 0,
                    bottom: 0,
                    opacity: 1,
                    height: "100%",
                    borderLeft: "5px solid var(--theme-color)",
                    margin: 0,
                  }}
                />
              )}
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="col-xl-8 px-2">
          <div className="">
            {/* Carbohydrate Content */}
            {activeBlend === "Lifestyle Management" && (
              <div
                id="Lifestyle-Management-content"
                className="main-background-color content-section-effectonhalth"
              >
                <div>
                  <div className="text-start"></div>
                </div>

                <div>
                  <div className="font-md">
                    <div className="custom-list-effectonhealth mb-2  text-white ">
                      <div className=" custom-list-item-height-two mb-1 font-xsm">
                        Treatment usually involves lifestyle changes :
                      </div>
                      <div className=" custom-list-item-height-two font-xsm justify_content">
                        <span className="me-2 bullet_point_white"> </span>
                        <span className="fw-semibold  mb-1">
                          {" "}
                          Healthy diet :{" "}
                        </span>{" "}
                        A heart-healthy eating plan includes fruits, vegetables,
                        and whole grains and limits saturated fats, sodium
                        (salt) and alcohol. Carbohydrate restriction is a
                        scientific approach to manage metabolic syndrome.
                      </div>
                      <div className=" custom-list-item-height-two font-xsm justify_content">
                        <span className="me-2 bullet_point_white"> </span>  
                        <span className="fw-semibold  mb-1">
                          {" "}
                          Aim for a healthy weight :{" "}
                        </span>{" "}
                        Losing just 3% to 5% of your current weight can help
                        manage some risk factors, such as high blood cholesterol
                        and diabetes
                      </div>
                      <div className=" custom-list-item-height-two font-xsm justify_content">
                        <span className="me-2 bullet_point_white"> </span>
                        <span className="fw-semibold  mb-1">
                          {" "}
                          Get regular physical activity :
                        </span>{" "}
                        Before starting any exercise program, ask about what
                        level of physical activity is right for you. 
                      </div>
                      <div className=" custom-list-item-height-two font-xsm justify_content">
                        <span className="me-2 bullet_point_white"> </span>
                        <span className="fw-semibold  mb-1">
                          {" "}
                          Manage stress:{" "}
                        </span>{" "}
                        Learning how to manage stress, relax, and cope with
                        problems can improve your emotional and physical health.
                      </div>
                      <div className=" custom-list-item-height-two font-xsm">
                        <span className="me-2 bullet_point_white"> </span>
                        <span className="fw-semibold  mb-1">
                          {" "}
                          Quit smoking{" "}
                        </span>{" "}
                     
                      </div>
                    


                   

                      <div className="font-xsm fw-semibold color-black-abdominal justify_content">
                        Losing even a modest amount of weight can lower blood
                        pressure and increase sensitivity to insulin. It can
                        also reduce the amount of belly fat. Diet, behavioural
                        counselling, and exercise lower risk factors.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Protein Content */}
            {activeBlend === "Healthy diet" && (
              <div
                id="Healthy-diet-content"
                className="main-background-color content-section-effectonhalth"
              >
                <div>
                  <div>
                    <div className="text-start"></div>
                  </div>
                </div>

                <div className="mt-3 text-white">
                  <div>
                    <div className="font-xsm mb-3 justify_content">
                      Changes in diet are important in treating metabolic
                      syndrome. According to the AHA, treating insulin
                      resistance is the key to changing other risk factors. In
                      general, the best way to treat insulin resistance is by
                      losing weight and getting more physical activity. Several
                      studies have shown that losing weight by reduced
                      carbohydrate intake reduced the risk of metabolic
                      syndrome.
                    </div>
                    <div className="font-xsm mb-1 fw-semibold color-black-abdominal">
                      Metabolic syndrome risk may be reduced with low-carb diet
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Fat Content */}
            {activeBlend === "Reduced Carbohydrates and Metabolic syndrome" && (
              <div
                id="Lifestyle-Management-content"
                className="main-background-color content-section-effectonhalth"
              >
                <div>
                  <div className="text-start"></div>
                </div>

                <div>
                  <div className="font-md">
                    <div className="custom-list-effectonhealth mb-2  text-white ">
                      <div className=" custom-list-item-height-two mb-1 font-xsm color-black-abdominal fw-semibold justify_content">
                        The latest new study published in Journal of Clinical
                        Investigation Insight (2024) suggests that low-carb diet
                        may have benefits for people at risk of developing type
                        2 diabetes even if they don’t lose any weight.
                      </div>
                      <div className=" custom-list-item-height-two font-xsm justify_content">
                        <span className="me-2 bullet_point_white"> </span>
                        It included 16 men and women with metabolic syndrome,
                        who saw their metabolic syndrome reversed even though
                        they were fed diets that intentionally contained enough
                        calories to keep their weight stable. After eating the
                        low-carb diet, the participants had a variety of
                        significantly improved health measures, particularly
                        lower triglycerides and improved cholesterol readings. 
                      </div>
                      <div className=" custom-list-item-height-two font-xsm justify_content">
                        <span className="me-2 bullet_point_white"> </span>
                        The researchers also reported evidence of increased
                        fat-burning efficiency after a low-carb diet and an
                        improvement in blood sugar.
                      </div>

                      <div className=" custom-list-item-height-two font-xsm justify_content">
                        <span className="me-2 bullet_point_white"> </span>
                        In another study exploring the role of a lowering
                        carbohydrates in patients with metabolic syndrome found
                        that a rapid reversal could be achieved in just 4 weeks
                        with lasting improvements in postprandial insulin
                        sensitivity.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Vitamin Content */}
            {activeBlend === "Exercise" && (
              <div
                id="Exercise-content"
                className="main-background-color content-section-effectonhalth"
              >
                <div>
                  <div>
                    <div className="text-start"></div>
                  </div>
                </div>

                <div className="mt-3">
                  <div>
                    <div className="font-xsm mb-3 text-white justify_content">
                      Exercise helps people who are overweight or obese by
                      helping to keep and add lean body mass, or muscle tissue,
                      while losing fat. It also helps you lose weight faster
                      than just following a healthy diet because muscle tissue
                      burns calories faster.
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Fiber Content */}
            {activeBlend === "Medicine" && (
              <div
                id="Medicine-content"
                className="main-background-color content-section-effectonhalth"
              >
                <div className="font-xsm mb-3 text-white justify_content">
                  People who have metabolic syndrome or are at risk for it may
                  need to take medicine as treatment. This is especially true if
                  diet and other lifestyle changes have not made a difference.
                  Your doctor may prescribe medicine suitable for you.  Consult
                  your physician before initiating any of the above.
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EffectsOnHealth;
